import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { LeadForm } from "./LeadForm";

export const EnquiryPopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("veera_popup_dismissed")) return;
    const t = setTimeout(() => setOpen(true), 8000);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    localStorage.setItem("veera_popup_dismissed", "1");
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          onClick={close}
          className="fixed inset-0 z-[90] flex items-center justify-center bg-navy/60 p-4 backdrop-blur-sm"
          data-testid="enquiry-popup-backdrop"
        >
          <motion.div
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, y: 40, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.98 }}
            transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
            className="relative max-h-[85vh] w-full max-w-lg overflow-y-auto rounded-xl bg-white p-8 shadow-lift"
            data-testid="enquiry-popup"
            data-lenis-prevent="true"
          >
            <button
              onClick={close}
              data-testid="popup-close-btn"
              aria-label="Close enquiry popup"
              className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-md border border-border text-gray-500 transition-colors duration-300 hover:border-navy hover:text-navy"
            >
              <X size={16} />
            </button>

            <img src="/assets/veera-tripod.png" alt="Urban Veera" className="h-10 w-auto" />
            <h3 className="mt-5 font-display text-2xl font-extrabold tracking-tight text-navy" data-testid="popup-heading">
              Get a free callback
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-gray-600">
              Share your details and your requirement — we'll call you back
              with a plan and real numbers.
            </p>

            <div className="mt-7">
              <LeadForm idPrefix="popup" compact />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
